import { render, staticRenderFns } from "./BaseListItem.vue?vue&type=template&id=0111c865&scoped=true&"
import script from "./BaseListItem.vue?vue&type=script&lang=js&"
export * from "./BaseListItem.vue?vue&type=script&lang=js&"
import style0 from "./BaseListItem.vue?vue&type=style&index=0&id=0111c865&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0111c865",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VAvatar,VChip,VIcon})
